import { render, staticRenderFns } from "./selectPlanNepal.vue?vue&type=template&id=c4615eb8&scoped=true&"
import script from "./selectPlanNepal.vue?vue&type=script&lang=js&"
export * from "./selectPlanNepal.vue?vue&type=script&lang=js&"
import style0 from "./selectPlanNepal.vue?vue&type=style&index=0&id=c4615eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4615eb8",
  null
  
)

export default component.exports